const routes = {
  HOME: `/`,
  CREATE: `/create`,
  DEVICE: `/devices`,
  MEETING: `/meeting`,
};

export default routes;
